import {EventSubscriber, HasEventName} from "@/modules/base/events";
import {inject, injectable} from "inversify";
import {TYPES} from "@/modules/vue";
import {Router} from "vue-router";
import UserMatchHandler from "@/modules/match/services/UserMatchHandler";
import {Application} from "@/di";
import {BeforeMatchEvent} from "@/modules/match/events/BeforeMatchEvent";
import LiveMatchEvaluator from "@/modules/match/services/LiveMatchEvaluator";

@injectable()
export class UserMatchEvaluationEventSubscriber implements EventSubscriber {
  constructor(
    @inject(UserMatchHandler) private userMatchHandler: UserMatchHandler,
    @inject(Application) private app: Application,
  ) {}

  priority(): number {
    return 0;
  }

  init(): { event: HasEventName; callback: (event: any) => void }[] {
    return [
      {event: BeforeMatchEvent, callback: this.onBeforeMatchEvent},
    ];
  }

  async onBeforeMatchEvent(event: BeforeMatchEvent): Promise<void> {
    if (!event.match.homeTeam.user && !event.match.awayTeam.user) {
      return;
    }

    LiveMatchEvaluator.nextMatch = event.match;

    await this.app.get<Router>(TYPES.VueRouter).push({
      name: 'matches.evaluation.before',
      params: {id: event.match.id},
      // @ts-ignore
      query: {ready: true},
    });

    await this.userMatchHandler.start();
  }
}